import { render, staticRenderFns } from "./groupDetails.vue?vue&type=template&id=40e1e45a&scoped=true"
import script from "./groupDetails.vue?vue&type=script&lang=js"
export * from "./groupDetails.vue?vue&type=script&lang=js"
import style0 from "./groupDetails.vue?vue&type=style&index=0&id=40e1e45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e1e45a",
  null
  
)

export default component.exports